module.exports = __webpack_public_path__ + "static/media/temperature-up.9b60d748.svg";